import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CartHeader from "../Cart/Header";
import axios from "axios";

import { printReceipt } from "../../../Utils/printer";
import SuccessImage from "../../../Assets/Success.png";

import "./OrderSuccess.css";

export default function OrderSuccess() {
  const location = useLocation();

  const [order, setOrder] = useState(null);

  const orderId =
    location.state?.orderId || location.state?.id;

  // ---------------------------------------------
  // Fetch Order + Print
  // ---------------------------------------------
  useEffect(() => {
    if (!orderId) {
      console.error("No Order ID found");
      return;
    }

    const fetchOrder = async () => {
      try {
        const res = await axios.get(
          `https://fliplyn-b-c.fly.dev/orders/${orderId}`
        );

        console.log("Order Data:", res.data);

        setOrder(res.data);

        // 🔥 PRINT RECEIPT
        try {
          await printReceipt(res.data);
        } catch (err) {
          console.error("Print failed:", err);
        }
      } catch (err) {
        console.error("Failed to fetch order:", err);
      }
    };

    fetchOrder();
  }, [orderId]);

  // Auto redirect
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/user";
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!order) return null;

  return (
    <div className="os-page">
      <CartHeader />

      <main className="os-container">

        {/* TOKEN RECEIPT DESIGN */}
        <div className="token-card">

          <h1 className="token-title">Tea Topia</h1>

          <p className="token-number">
            Token No: <strong>{order.token_number}</strong>
          </p>

          <div className="token-divider" />

          <p className="token-date">
            {new Date(order.created_datetime).toLocaleString()}
          </p>

          <div className="token-divider" />

          {/* ITEMS */}
          <div className="token-items">
            <div className="token-row header">
              <span>Item</span>
              <span>Rs</span>
            </div>

            {order.order_details.map((item, index) => (
              <div key={index} className="token-row">
                <span>
                  {item.name} × {item.quantity}
                </span>
                <span>{item.total.toFixed(2)}</span>
              </div>
            ))}
          </div>

          <div className="token-divider" />

          {/* TAX */}
          <div className="token-summary">
            <div className="token-row">
              <span>CGST</span>
              <span>{order.cgst.toFixed(2)}</span>
            </div>

            <div className="token-row">
              <span>SGST</span>
              <span>{order.sgst.toFixed(2)}</span>
            </div>

            <div className="token-row">
              <span>Total GST</span>
              <span>{order.total_gst.toFixed(2)}</span>
            </div>

            <div className="token-row">
              <span>Total</span>
              <span>{order.total_amount.toFixed(2)}</span>
            </div>

            <div className="token-row">
              <span>Round Off</span>
              <span>{order.round_off.toFixed(2)}</span>
            </div>
          </div>

          <div className="token-divider solid" />

          <div className="token-grand">
            <span>Grand Total</span>
            <span>{order.total_amount.toFixed(2)}</span>
          </div>
        </div>

        {/* SUCCESS UI */}
        <div className="os-card">
          <img src={SuccessImage} alt="success" />
          <h2>Order Successful</h2>
          <p>Token #{order.token_number} is being prepared</p>
        </div>

      </main>
    </div>
  );
}